import Chart from 'chart.js'

export default class PortfolioChart {
  constructor () {
    var ctx = document.getElementById('portfolio-overview').getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'horizontalBar',
      data: {
        labels: [],
        datasets: [
          {
            // label: '',
            data: [],
            backgroundColor: [
              'rgba(42, 10, 78, 1)',
              'rgba(62, 34, 95, 1)',
              'rgba(84, 59, 113, 1)',
              'rgba(105, 83, 130, 1)',
              'rgba(127, 108, 148, 1)',
              'rgba(148, 132, 166, 1)',
              'rgba(169, 157, 184, 1)',
              'rgba(191, 181, 202, 1)',
              'rgba(212, 206, 219, 1)',
              'rgba(234, 230, 237, 1)'
            ],
            hoverBorderColor: [
              'rgba(42, 10, 78, 1)',
              'rgba(62, 34, 95, 1)',
              'rgba(84, 59, 113, 1)',
              'rgba(105, 83, 130, 1)',
              'rgba(127, 108, 148, 1)',
              'rgba(148, 132, 166, 1)',
              'rgba(169, 157, 184, 1)',
              'rgba(191, 181, 202, 1)',
              'rgba(212, 206, 219, 1)',
              'rgba(234, 230, 237, 1)'
            ],
            hoverBorderWidth: 1
          }
        ]
      },
      options: {
        layout: {
          padding: {
            right: 50
          }
        },
        onClick: this.graphClickEvent,
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              barThickness: 5,
              gridLines: {
                display: false
              },
              ticks: {
                display: false,
                
              },
              
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: false,
                offsetGridLines: true
              },
              ticks: {
                padding: 10,
                callback: ticksCallback,
                fontFamily: "'heldane-text-bold'"
              }
            }
]
        },
        showAllTooltips: true,
        tooltips: {
          backgroundColor: 'rgba(0,0,0,0)',
          bodyFontColor: '#000',
          bodyFontFamily: "'heldane-text-regular'",
          bodyFontSize: 13,
          titleFontColor: '#000',
          titleFontFamily: "'heldane-text-regular'",
          titleFontSize: 13,
          titleFontStyle: 'normal',
          yAlign: 'center',
          xAlign: 'left',
          yPadding: 10,
          displayColors: false,
          callbacks: {
            label: titleCallback,
            title: tooltipsCallback
          }
        }
      },
      plugins: [
        {
          beforeRender: chart => {
            if (chart.config.options.showAllTooltips) {
              // create an array of tooltips
              // we can't use the chart tooltip because there is only one tooltip per chart
              chart.pluginTooltips = []
              chart.config.data.datasets.forEach((dataset, i) => {
                chart.getDatasetMeta(i).data.forEach((sector, j) => {
                  chart.pluginTooltips.push(
                    new Chart.Tooltip(
                      {
                        _chart: chart.chart,
                        _chartInstance: chart,
                        _data: chart.data,
                        _options: chart.options.tooltips,
                        _active: [sector]
                      },
                      chart
                    )
                  )
                })
              })

              // turn off normal tooltips
              chart.options.tooltips.enabled = false
            }
          },
          afterDraw: (chart, easing) => {
            if (chart.config.options.showAllTooltips) {
              // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
              if (!chart.allTooltipsOnce) {
                if (easing !== 1) return
                chart.allTooltipsOnce = true
              }

              // turn on tooltips
              chart.options.tooltips.enabled = true
              Chart.helpers.each(chart.pluginTooltips, tooltip => {
                tooltip.initialize()
                tooltip.update()
                // we don't actually need this since we are not animating tooltips
                tooltip.pivot()
                tooltip.transition(easing).draw()
              })
              chart.options.tooltips.enabled = false
            }
          }
        }
      ]
    })
  }

  updatePortfolioOverviewData (data) {
    data.sort((a, b) => {
      return (
        parseFloat(Object.values(b)[0].value) -
        parseFloat(Object.values(a)[0].value)
      )
    })
    const labels = data.map(y => Object.keys(y))
    const dataset = data.map(y => Object.values(y)[0].value)
    const ids = data.map(y => Object.values(y)[0].id)
    const topLabels = labels.slice(0, 10)
    const topDataset = dataset.slice(0, 10)
    const topIds = ids.slice(0, 10)
    this.chart.data.ids = topIds
    this.chart.data.labels = topLabels
    this.chart.data.datasets[0].data = topDataset
    // this.chart.data.datasets[1].data = topDataset
    this.chart.update()
  }

  graphClickEvent (event, array) {
    if (array[0]) {
      window.location =
        '/portfolio/detail/' + this.chart.data.ids[array[0]._index]
    }
  }
}

const tooltipsCallback = (tooltipItem, data) => {
  return ''
}

// Put title on multiple lines to stop overlaps
const titleCallback = (tooltipItem, data) => {
  var label = data.labels[tooltipItem.index] || ''
  if (label) {
    label += ': '
  }
  let value = Math.round(tooltipItem.xLabel / 1000000 * 1000) / 1000
  label = ' $' + value + 'M'
  // return label

  let text = tooltipItem.yLabel[0]

  return text + label
  // if (text.indexOf(' ', 8) > 0) {
  //   let lineBreaks = text.split(/(.{7}[^ ]* )/g)
  //   return lineBreaks.filter(x => x !== '')
  // } else {
  //   return text
  // }
}

const ticksCallback = (value, index, values) => {
  return '$' + (Math.round(value / 1000000 * 1000) / 1000).toLocaleString(undefined, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1
  }) + 'M'
}



// WEBPACK FOOTER //
// ./assets/j/src/charts/portfolio_overview.js